import { useEffect, useState } from 'react';
import { ProductVideo } from './productVideo.js';
import { ProductFileResource } from './productFileResource.js';
import { getStaticAppSettings } from './../../utils/envService'

export const AnswerProduct = (props) => {

  const { resourceId, resource} =  props;

  const [ urlWithSasHere, setUrlWithSasHere ] = useState(false)
  const [ loadingUrlWithSasHere, setLoadingUrlWithSasHere] = useState(false)

  // useEffect(() => {

  //     if(resourceId){

  //     getPublicResource(resource.id, 'en-GB')
  //     isAddedToMyLibrary(resource.id)
  //     }


  //         if(!resourceId && urlWithSas){
  //             clearUrlWithSas()
  //         }
  


  // }, [resourceId])


  const getPublicResource = (resourceId,lang) => {

    //get resource TODO
      // props.resourceActions.getPublicResource(resourceId, lang)
  }

 
  const getUrlWithSas = () => {

    setUrlWithSasHere(false)
    setLoadingUrlWithSasHere(true)

    getStaticAppSettings(process.env.NODE_ENV).then((settings) => {
        
        const apiBaseUrl = `${settings.MAPPING_API_URL}/resource/url-with-sas?inputUrl=${resource.id}`
        return fetch(apiBaseUrl, {
          method: 'GET',
          headers: {
              "Content-Type": 'application/json',
            },
          }) 
        .then(response => {

          return response.text(); // This returns a promise
        })
        .then(data => {
          setLoadingUrlWithSasHere(false)
          setUrlWithSasHere(data)
        })
      

            // setLessons(response.data)
          
            

        })
      .catch(error => {
          console.error('Failed to load environment variables:', error);
      });
    
    

    
    }

    const clearUrlWithSas = () => {


      // clearUrlWithSas TODO
      // return props.resourceActions.clearUrlWithSas()

    }

    const downloadResource = (res) => {
  
      //download

      // const resourceInt = Number.isInteger(res.id) ? res.id : parseInt(res.id.split('_')[1],10)
      // const apiBaseUrl = `${config.apiUrl}fileupload/download`;
      // const fileName = res.title ? res.title.replace(/\.|(\r\n|\n|\r)/g, '') : res.description.replace(/\.|(\r\n|\n|\r)/g, '');
      // // const blob = { Url: res.url, Name: fileName, IsExternalFile: res.isExternalFile, AddLicenseWatermark: true,IsPublic: res.publicStatusId, ResourceId: resourceInt, isPreview: false, isFromPlanner: false   };
      // const blob = { Url: res.url, Name: fileName, IsExternalFile: false, AddLicenseWatermark: true,IsPublic: 1, ResourceId: resourceInt, isPreview: false, isFromPlanner: false   };
      // axios
      //   .post(apiBaseUrl, blob, {
      //     headers: authHeader(),
      //     responseType: "blob", //Force to receive data in a Blob Format
      //   })
      //   .then(function (response) {
      //     var blob = new Blob([response.data], { type: response.data.type });
      //     saveAs(blob, fileName);
      //   })
      //   .catch(function (error) {
      //     console.log(
      //       "Looks like there was a problem: \n",
      //       error.response.data
      //     );
      //     //component.setState({ printingmessage: error.response.data })
      //   });
    }

    const  isAddedToMyLibrary = (resourceId) => {

      //TODO

      // const apiBaseUrl = `${config.apiUrl}resources/isAddedToMyLibrary/?resourceId=${resourceId}`;
      // axios
      // .get(apiBaseUrl, {
      //   headers: authHeader(),

      // })
      // .then(function (response) {
      //     setResourceIsAdded(response.data)
      // })
      // .catch(function (error) {
      //   console.log(
      //     "Looks like there was a problem: \n",
      //     error.response.data
      //   );
      //   //component.setState({ printingmessage: error.response.data })
      // });


    }



  //   const removeFromMyLibrary = (resource) => {

  //     const apiBaseUrl = `${config.apiUrl}myLibrary/resourceToMyLibrary/?item=${resourceId}&lang=en-GB`;
  //     axios
  //     .post(apiBaseUrl, {
  //       headers: authHeader(),

  //     })
  //     .then(function (response) {
  //         setResourceIsAdded(true)
  //     })
  //     .catch(function (error) {
  //       console.log(
  //         "Looks like there was a problem: \n",
  //         error.response.data
  //       );
  //       //component.setState({ printingmessage: error.response.data })
  //     });
      
  //     props.myLibraryActions.removeResourceFromMyLibrary(resource.id, folder, false);
  // }
    

  return(

     
              <div>

                  {resource &&

                  <div className="gpt-message__product--contents">
                         {resource.resourceformat === "video" ?

                         <ProductVideo resource={resource} getUrlWithSas={getUrlWithSas} urlWithSas={urlWithSasHere} loadingUrlWithSas={loadingUrlWithSasHere} clearUrlWithSas={clearUrlWithSas} downloadResource={downloadResource} />

                         :

                          <ProductFileResource product={resource} getUrlWithSas={getUrlWithSas} urlWithSas={urlWithSasHere} loadingUrlWithSas={loadingUrlWithSasHere} downloadResource={downloadResource}/>

                      }

           

                  </div>
                  
                  }

                  </div>
          
                  
    
  )


}